// Yapışkan sepet çubuğu: ana "Sepete Ekle" ekrandan yukarı çıkınca alttan görünür; varyant değişince güncellenir.
if (!customElements.get('p1-yapiskan-sepet')) {
  customElements.define(
    'p1-yapiskan-sepet',
    class P1YapiskanSepet extends HTMLElement {
      connectedCallback() {
        this.buton = this.querySelector('button[name="add"]');
        this.varyantGirdisi = this.querySelector('[data-p1-varyant]');
        this.fiyat = this.querySelector('[data-p1-fiyat]');
        this.anaButon = document.querySelector('.product__info-container .product-form__buttons');
        if (!this.anaButon) return;

        this.gozcu = new IntersectionObserver(([giris]) => {
          const yukarida = !giris.isIntersecting && giris.boundingClientRect.top < 0;
          this.goster(yukarida);
        });
        this.gozcu.observe(this.anaButon);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.abonelik = subscribe(PUB_SUB_EVENTS.variantChange, (olay) => this.varyantDegisti(olay.data));
        }
      }

      disconnectedCallback() {
        this.gozcu?.disconnect();
        if (typeof this.abonelik === 'function') this.abonelik();
        document.body.classList.remove('p1-yapiskan-acik');
      }

      goster(acik) {
        this.classList.toggle('p1-yapiskan--acik', acik);
        this.setAttribute('aria-hidden', acik ? 'false' : 'true');
        if (this.buton) this.buton.tabIndex = acik ? 0 : -1;
        document.body.classList.toggle('p1-yapiskan-acik', acik);
      }

      varyantDegisti(veri) {
        if (!veri || !veri.variant) {
          if (this.buton) this.buton.setAttribute('disabled', 'disabled');
          return;
        }
        if (this.varyantGirdisi) this.varyantGirdisi.value = veri.variant.id;
        if (this.buton) {
          if (veri.variant.available) this.buton.removeAttribute('disabled');
          else this.buton.setAttribute('disabled', 'disabled');
        }
        const yeniFiyat = veri.html && veri.html.querySelector(`#price-${veri.sectionId}`);
        if (yeniFiyat && this.fiyat) this.fiyat.innerHTML = yeniFiyat.innerHTML;
      }
    }
  );
}
